import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

import { open } from './actions'
import { COLLATERAL_FORM_NAME } from './constants'

const CollateralFormModal = Loadable(() => import('./CollateralForm'))

export const createCollateralFormNavigationItem = createNavigationConfig((translateFn: (key: string) => string) => ({
  icon: 'collateral_add',
  text: translateFn('mnu_coll_add'),
  identity: COLLATERAL_FORM_NAME,
  premission: 'ADD_COLLATERAL',
  component: CollateralFormModal,
}))

export { open }

export default CollateralFormModal
